import { useEffect } from 'react';
import { toast } from 'sonner';

export function useServiceWorkerUpdate() {
  useEffect(() => {
    const handleSWUpdate = () => {
      toast.info('Update available!', {
        description: 'A new version is ready. Click to refresh.',
        duration: Infinity,
        action: {
          label: 'Refresh',
          onClick: () => window.location.reload(),
        },
      });
    };

    window.addEventListener('sw-updated', handleSWUpdate);
    return () => window.removeEventListener('sw-updated', handleSWUpdate);
  }, []);
}
